// #2692 意図して止めたときの画面の文言。
//
// API を公開から外す (Maintenance の workflow) と画面は API から何も取れないので、
// 文言は画面が直接読める所 = Firestore の `platform_config/maintenance` に置く
// (ルールで誰でも読める・書けない。書くのは workflow の SA だけ)。
// 無い・active でない・読めない (オフライン等) ときは null を返し、画面は今までの
// 障害の文言 (maintenance.server.*) を出す。
import { doc, getDoc } from 'firebase/firestore'
import { firestoreDb } from './firebase'

export interface MaintenanceNotice {
  active: true
  title: { ja?: string; en?: string }
  message: { ja?: string; en?: string }
  /** いつまで。自由な文字列 (例: ja "11月5日 18:00" / en "Nov 5, 18:00 JST")。画面はそのまま出す */
  until: { ja?: string; en?: string }
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined)
const texts = (v: unknown): { ja?: string; en?: string } => {
  const m = (v && typeof v === 'object' ? v : {}) as Record<string, unknown>
  return { ja: str(m.ja), en: str(m.en) }
}

export async function fetchMaintenanceNotice(): Promise<MaintenanceNotice | null> {
  try {
    const snap = await getDoc(doc(firestoreDb, 'platform_config', 'maintenance'))
    if (!snap.exists()) return null
    const d = snap.data() as Record<string, unknown>
    if (d.active !== true) return null
    return { active: true, title: texts(d.title), message: texts(d.message), until: texts(d.until) }
  } catch {
    // ルールで読めない・オフライン → 既定の文言に任せる
    return null
  }
}
